export enum IncomingBankPaymentOperationTypeEnum {
  CustomerPayment = 0,
  TransferFromAnotherAccount = 1,
  CashDepositToBank = 2,
  LoanRepaymentByCounterparty = 3,
  DepositInterest = 4,
  LoanRepaymentByEmployee = 5,
  CurrencyConversion = 6,
  OtherPayment = 7,
  VendorRefund = 8,
  ReturnFromAdvanceHolder = 9,
}